<script setup lang="ts">
import { Check } from '@lucide/vue'

defineProps<{
  steps: string[]
  /** Zero-based index of the step being shown. */
  current: number
}>()
</script>

<template>
  <ol class="flex flex-wrap items-center gap-x-3 gap-y-2">
    <li v-for="(step, index) in steps" :key="step" class="flex items-center gap-3">
      <span v-if="index > 0" aria-hidden="true" class="bg-border hidden h-px w-8 sm:block" />
      <span
        class="flex items-center gap-2.5 text-sm"
        :aria-current="index === current ? 'step' : undefined"
      >
        <span
          class="flex size-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold"
          :class="
            index < current
              ? 'bg-green-600 text-white'
              : index === current
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted text-muted-foreground'
          "
        >
          <Check v-if="index < current" class="size-4" />
          <template v-else>{{ index + 1 }}</template>
        </span>
        <span
          :class="index === current ? 'text-foreground font-semibold' : 'text-muted-foreground'"
        >
          {{ step }}
        </span>
      </span>
    </li>
  </ol>
</template>
